export default "__VITE_ASSET__B2954hKk__"